module.exports = __webpack_public_path__ + "static/img/4-1.fb56e15b.png";